import $ from "jquery";

let i18 = {
    "pl": {
        "Account deleted": "Konto usunięte"
    }
}

function t(message) {
    if (lang === "en") return message;
    if (lang === "pl") return i18['pl'][message] ? i18['pl'][message] : message;
}

let lang = document.documentElement.getAttribute("lang").toLowerCase() === "pl" ? "pl" : "en";

var GPPYDeleteAccount = {
    init: function() {
        $('.deleteAccount a').click(GPPYDeleteAccount.deleteAccount);
        $('#deleteConfirm').on('keyup',GPPYDeleteAccount.handleConfirmInput);
    },

    handleConfirmInput: function(e) {
        if ($('#deleteConfirm').val() === "DELETE" || $('#deleteConfirm').val() === "USUŃ" )
            $('.deleteAccount a').removeClass('disabled')
        else
            $('.deleteAccount a').addClass('disabled')
    },

    deleteAccount: function() {
        Promise.resolve($.post('/api/deleteAccount/', {
            'delete' : $('#deleteConfirm').val()
        })).then(
            GPPYDeleteAccount.deleted,
            GPPYDeleteAccount.showError)

    },

    showError: function(res) {
        var processErrors = function(errors, target) {
            var errorshtml = errors.map(function(el){return '<span class="help-block">'+el+'</span>'});
            errorshtml =  errorshtml.reduce(function(con, el){return con+el},"");
            target.html(errorshtml).removeClass("hidden").addClass("has-error");
        }

        var errs = res.responseJSON.form_errors;
        processErrors(errs,$('.deleteAccountErrors'));
    },

    deleted: function() {
        $('.deleteAccountErrors').html(t("Account deleted")).removeClass("hidden").removeClass("has-error");
        setTimeout(function () {
            location.href = "/"
        }, 2000)
    }
}

$('document').ready(GPPYDeleteAccount.init);

